import { render, staticRenderFns } from "./wxScan.vue?vue&type=template&id=6770a178&scoped=true&"
import script from "./wxScan.vue?vue&type=script&lang=js&"
export * from "./wxScan.vue?vue&type=script&lang=js&"
import style0 from "./wxScan.vue?vue&type=style&index=0&id=6770a178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6770a178",
  null
  
)

export default component.exports